<template>
  <v-container grid-list-xs fill-height>
    <v-img class="background" src="/img/background-blur.jpg"></v-img>
    <v-layout align-center justify-center fill-height>
      <v-flex xs12 sm8 md6 xl4>
        <v-card class="elevation-12">
          <v-toolbar color="#BBA981" dark flat>
            <v-toolbar-title>Préparez-vous : </v-toolbar-title>
            <v-spacer />
          </v-toolbar>
          <v-card-text>
            <home-form :form="form" />
          </v-card-text>
          <v-card-actions v-if="!gameLoaded" class="px-4 pb-4">
            <v-spacer />
            <v-btn color="#BBA981" dark v-if="activeBtnJoinGame" @click="joinGame"> Rejoindre </v-btn>

            <v-dialog v-if="activeBtnNewGame" v-model="dialogNewGame" persistent max-width="600px">
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="#BBA981" dark v-bind="attrs" v-on="on"> Nouvelle </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <v-text-field label="Nom du jeu" v-model="form.game.name" :rules="gameRules" />
                </v-card-title>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="#BBA981" text @click="resetGame">Fermer</v-btn>
                  <v-btn color="#BBA981" dark @click="newGame" v-if="this.form.game.name && this.form.game.name.length > 4"> Créer </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-card-actions>
          <v-card-actions v-if="gameLoaded" class="d-flex flex-column">
            <div class="mb-5" v-if="!isDownloading">
              <v-btn color="#BBA981" dark @click="redirect"> Jouer </v-btn>
              <v-btn color="#BBA981" dark @click="prepareAssets(true)"> Précharger </v-btn>
            </div>
            <div v-if="isDownloading">
              <p class="mb-0">Nb chargements:{{ nbLoading }}</p>
              <hr />
              <p class="mb-0">Nb réussis:{{ nbLoaded }}</p>
              <hr />
              <p class="mb-0">Nb erreurs:{{ nbLoadedError }}</p>
            </div>
          </v-card-actions>
        </v-card>
        <hr />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  // Components imported
  import HomeForm from '../components/HomeForm.vue'

  /**
   * @brief Home view managing user quizz selection (btob/btoc).
   * @bug No known bugs.
   */
  export default {
    name: 'Home',
    components: { HomeForm },
    data: () => ({
      form: {
        scenario: {},
        game: {},
        team: undefined,
        is3d: undefined,
        map3d: undefined,
        useGoogleHome: false,
      },
      nbLoading: 0,
      nbLoaded: 0,
      nbLoadedError: 0,
      dialogNewGame: false,
      gameLoaded: false,
      gameRules: [(value) => !!value || 'Required.', (value) => (value && value.length >= 5) || 'Min 5 characters'],
    }),
    computed: {
      isSenarioSelected: function () {
        return this.form.scenario && 'id' in this.form.scenario
      },
      isGameSelected: function () {
        return this.form.game && 'id' in this.form.game
      },
      isTeamSelected: function () {
        return this.form.team && 'name' in this.form.team && this.form.team.name.length > 4
      },
      isBtobCallback: function () {
        return (value) => {
          return (this.form.scenario.type === 'btob' && value) || this.form.scenario.type === 'btoc'
        }
      },
      activeBtnNewGame: function () {
        return this.isSenarioSelected && !this.isGameSelected
      },
      activeBtnJoinGame: function () {
        return this.isSenarioSelected && this.isGameSelected && (this.form.scenario.type === 'btob' || this.isBtobCallback(this.isTeamSelected))
      },
      isDownloading: function () {
        return this.nbLoading !== this.nbLoaded + this.nbLoadedError && this.nbLoaded + this.nbLoadedError !== 0
      },
    },
    watch: {
      form: {
        handler(newValue) {
          if (newValue.game.id === undefined) {
            this.gameLoaded = false
            SAPIO.Game.LS_EMPTY()
            this.nbLoading = 0
            this.nbLoaded = 0
            this.nbLoadedError = 0
          }
        },
        deep: true,
      },
    },
    created() {
      SAPIO.Game.LS_EMPTY()
      SAPIO.Scenario.LS_EMPTY()
      SAPIO.Team.LS_EMPTY()
    },
    methods: {
      prepareAssets(load = false) {
        ;(this.nbLoading = 0), (this.nbLoaded = 0), (this.nbLoadedError = 0), this.prepareAssetsRec(SAPIO.Scenario.instance, load)
      },
      prepareAssetsRec(o, load) {
        const output = Array.isArray(o) ? [] : {}
        for (const key in o) {
          const v = o[key]
          if (typeof v === 'object') this.prepareAssetsRec(v, load)
          else {
            if (typeof v === 'string') {
              const _url = `${v}`
              const cacheName = /(http(s?):)([/|.|:|\w|\s|-])*\.(?:mp3)$/.test(_url) ? 'sounds' : /(http(s?):)([/|.|:|\w|\s|-])*\.(?:jpg|gif|png|jpeg)$/.test(v) ? 'images' : ''
              let url = _url
              if (/(http(s?):)([/|.|:|\w|\s|-])*\.(?:mp3)$/.test(_url)) url = url.replace('/storage/files/', '/sounds/')
              if (cacheName !== '') this.nbLoading += 1
              if (cacheName !== '' && load) fetch(url).then((res) => {
                return caches.open(cacheName).then((cache) => {
                  this.nbLoaded += 1
                  return cache.put(_url, res)
                }).catch((e) => {
                  this.$notify({ group: 'app', type: 'error', title: 'Erreur lors du préchargement', text: e.message })
                  console.error(e)
                  this.nbLoadedError += 1
                })
              })
            }
            output[key] = v
          }
        }
        return output
      },
      newGame() {
        this.dialogNewGame = false
        SAPIO.Loader.instance.createGame({
          scenario_id: this.form.scenario.id,
          name: this.form.game.name,
          user_id: SAPIO.User.instance.id,
          useGoogleHome: this.form.useGoogleHome,
        }).then((newGame) => {
          this.form.game = newGame
          this.$notify({ group: 'app', type: 'info', title: 'Nouvelle partie crée !', text: `Nom de la partie :${this.form.game.name}` })
          this.joinGame()
        }).catch((e) => {
          this.$notify({ group: 'app', type: 'error', title: 'Erreur lors de la création de la partie', text: e.message })
          console.error(e)
        })
      },
      resetGame() {
        this.dialogNewGame = false
        this.form.game = {}
      },
      async joinGame() {
        if (this.form.scenario.type === 'btob') {
          if (SAPIO.User.instance.id === this.form.game.user_id) SAPIO.Game.instance.addTeam(-1, 'Master')
          if (SAPIO.User.instance.id !== SAPIO.Game.instance.user_id) {
            if (this.form.team && !this.form.team.id) {
              const newTeam = await SAPIO.Loader.instance.createTeamOnGame({
                game_id: this.form.game.id,
                name: this.form.team.name,
                score: 0,
                status: 0,
                user_id: SAPIO.User.instance.id,
              })
              this.$notify({ group: 'app', type: 'info', title: 'Nouvelle équipe crée !', text: `L'équipe ${newTeam.name} rejoint la partie` })
              this.form.team.id = newTeam.id
              SAPIO.Game.instance.addTeam(newTeam.id, newTeam.name)
              SAPIO.Team.createFromJson({id: newTeam.id, user_id: newTeam.id,  name: newTeam.name})
              SAPIO.Team.instance.LS_SAVE()
            } else {
              SAPIO.Game.instance.addTeam(this.form.team.id, this.form.team.name)
              SAPIO.Team.createFromJson({id: this.form.team.id, user_id: this.form.team.user_id,  name: this.form.team.name})
              SAPIO.Team.instance.LS_SAVE()
            }
          }
        } else {
          SAPIO.Game.instance.addTeam(SAPIO.User.instance.id)
        }
        SAPIO.Game.instance.LS_SAVE()
        this.loadGame()
      },
      redirect() {
        if (this.form.scenario.type === 'btob' && SAPIO.User.instance.id === this.form.game.user_id) this.$router.push({ path: '/master' });
        else {
          if (this.form.is3d == 0) this.$router.push({ path: '/game' });
          else if (this.form.is3d == 1) this.$router.push({ name: 'gamecanvas', params: { map: this.form.map3d }})
        }
      },
      loadGame() {
        this.$notify({ group: 'app', type: 'info', title: 'Scenario chargé !', text: 'Vous allez bientôt pouvoir jouer' })
        this.gameLoaded = true
        this.prepareAssets()
      },
    },
  }
</script>

<style scoped>
  .background {
    position: fixed;
    top: 0;
    left: 0;
    min-width: 100%;
    min-height: 100%;
  }
</style>